// push one field to current location search

import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';

function usePushLocationSearch() {
  const location = useLocation();
  const history = useHistory();

  function handlePushLocationSearch(data: object) {
    const locationSearch = qs.parse(location.search.slice(1));
    history.push({
      search: `?${qs.stringify({ ...locationSearch, ...data }, { encode: true, indices: false })}`,
    });
  }

  return handlePushLocationSearch;
}

export default usePushLocationSearch;
